import { useUiStore } from '@/shared/store/ui-store';
import { valueComparedToTailwindBreakpointIs } from '@/utils/tailwind';
import { useEffect, useRef } from 'react';

export function useResizeObserver() {
  const resizeTimeout = useRef<NodeJS.Timeout | null>(null);
  const resizing = useRef(false);
  const windowWidthAtStart = useRef(window.innerWidth);
  const { isMenuSidebarOpen, setIsMenuSidebarOpen } = useUiStore();

  useEffect(() => {
    const handleResize = () => {
      if (!resizing.current) {
        resizing.current = true;
        windowWidthAtStart.current = window.innerWidth;
      }

      if (resizeTimeout.current) {
        clearTimeout(resizeTimeout.current);
      }

      resizeTimeout.current = setTimeout(() => {
        const windowWidthAtEnd = window.innerWidth;
        resizing.current = false;

        if (
          valueComparedToTailwindBreakpointIs(
            windowWidthAtStart.current,
            'smaller',
            '2xl',
          ) &&
          valueComparedToTailwindBreakpointIs(
            windowWidthAtEnd,
            'bigger',
            '2xl',
          )
        ) {
          if (isMenuSidebarOpen) {
            setIsMenuSidebarOpen(false);
          }
        }
      }, 100);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      if (resizeTimeout.current) {
        clearTimeout(resizeTimeout.current);
      }
    };
  }, [isMenuSidebarOpen, setIsMenuSidebarOpen]);
}
